<main>
  <mat-toolbar>
    <h1>Complete Pest Control - {{mdl}}</h1>
    <span class="toolbar-spacer"></span>
    <button mat-fab extended (click)="newClick()">
      <mat-icon>add</mat-icon>
      Add {{mdl}}
    </button>
  </mat-toolbar>
  @if (itemsArr.length == 0) {
    <p>No {{mdl}} found</p>
  }
  @if (itemsArr.length > 0) {
    <mat-list>
      @for (item of itemsArr; track item) {
        <mat-list-item (click)="itemClick(item)">
          <span matListItemTitle>{{getDisplayValue(item)}}</span>
          @if (getSubtitle(item)) {
            <span matListItemLine>{{getSubtitle(item)}}</span>
          }
        </mat-list-item>
      }
    </mat-list>
  }
</main>